import React, { useMemo } from 'react';

import Skeleton from '@atlaskit/skeleton';

import { useAIAnswerContext } from '../../../../ai-answer-dialog/ai-answer-context';
import type {
	CarouselElement,
	PersonElement,
} from '../../../dynamic-layout-parser/types/dynamic-layout-section';
import { DynamicLayoutCarousel } from '../dynamic-layout-carousel';

import type { PersonData } from './subAgentTypes';

const RELATED_PEOPLE_SUB_AGENT_NAME = 'ENTITY_RELATED_PEOPLE';

export const DynamicLayoutRelatedPeople = () => {
	const { loading, dynamicLayoutSubAgentMessages } = useAIAnswerContext();
	const relatedPeopleMessage = useMemo(() => {
		return getSubAgentMessage(dynamicLayoutSubAgentMessages, RELATED_PEOPLE_SUB_AGENT_NAME);
	}, [dynamicLayoutSubAgentMessages]);

	const carouselData = useMemo(() => {
		if (!relatedPeopleMessage?.data || relatedPeopleMessage?.data === 'No Data Found') {
			return null;
		}

		try {
			const peopleData: PersonData[] = JSON.parse(relatedPeopleMessage.data);

			const children: PersonElement[] = peopleData.map((person) => ({
				tag: 'people-card',
				attributes: {
					name: person.name,
					job_title: person.jobTitle,
					avatar_url: person.avatarUrl,
				},
			}));

			const carouselComponent: CarouselElement = {
				tag: 'carousel',
				attributes: {
					title: 'Related People',
				},
				children,
			};

			return carouselComponent;
		} catch (error) {
			return null;
		}
	}, [relatedPeopleMessage?.data]);

	if (loading && !relatedPeopleMessage?.data) {
		return <Skeleton width="200px" height="16px" isShimmering />;
	}

	if (!relatedPeopleMessage?.data || relatedPeopleMessage?.data === 'No Data Found') {
		return null;
	}

	if (!carouselData) {
		return null;
	}

	return <DynamicLayoutCarousel component={carouselData} position="two-rows-bottom" />;
};

const getSubAgentMessage = (messages: any[], subAgentName: string) => {
	return messages.find((message) => message.sub_agent_name === subAgentName);
};
